import { render, staticRenderFns } from "./AddNewWhitelist.vue?vue&type=template&id=94db2c8a&scoped=true&"
import script from "./AddNewWhitelist.vue?vue&type=script&lang=js&"
export * from "./AddNewWhitelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94db2c8a",
  null
  
)

export default component.exports